import * as authentication from "../../common/actions/authentication";
import * as singleEpixSortiment from "../actions/singleEpixSortiment.js";

import Immutable from "seamless-immutable";
import {findStoreProduct} from "../util/storeProductMerger.js";

const defaultState = () => {
    return Immutable({
        isLoading: false,
        allResultsLoaded: false,
        resultCountString: "0",
        chainFilter: {
            chainType: 5,
            onlyAvailableForChain: false,
            onlyNews: false,
            searchString: ""
        },
        allProducts: [],
        newProducts: [],
        newProductsLoading: false,
        productDetail: {},
        invoiceGroups: []
    });
};

/**
 * Single chain Epix sortiment reducer
 * @param {Object} state
 * @param {{type: string}} action
 * @return {*}
 */
export default function(state = defaultState(), action) {
    switch (action.type) {
    case singleEpixSortiment.SET_SINGLE_EPIX_SORTIMENT:
        return state.merge({
            resultCountString: `${action.allProducts.length}${state.allResultsLoaded ? "" : "+"}`,
            allProducts: action.allProducts
        });
    case singleEpixSortiment.ADD_SINGLE_EPIX_SORTIMENT:
        return state.merge({
            resultCountString: `${state.allProducts.length + action.allProducts.length}${state.allResultsLoaded ? "" : "+"}`,
            allProducts: state.allProducts.concat(action.allProducts)
        });
    case singleEpixSortiment.UPDATE_SINGLE_EPIX_PRODUCT_LIST:
        return state.merge({
            allProducts: state.allProducts.map(p => findStoreProduct(p, action.products))
        });
    case singleEpixSortiment.SET_QUERY_PRODUCT_IMAGE_URL:
        return state.merge(
            {
                allProducts: Immutable(state.allProducts).map(function(obj, index) {
                    return index === action.index
                        ? {
                            product: {
                                ...obj.product,
                                imageUrl: action.imageUrl
                            }
                        }
                        : obj;
                })
            },
            {
                deep: true
            }
        );
    case singleEpixSortiment.SINGLE_EPIX_SORTIMENT_IS_LOADING:
        return state.merge({
            isLoading: true
        });
    case singleEpixSortiment.SINGLE_EPIX_QUERY_DONE_LOADING:
    case singleEpixSortiment.SINGLE_EPIX_QUERY_FAILED_LOADING:
        return state.merge({
            isLoading: false
        });
    case singleEpixSortiment.SINGLE_EPIX_QUERY_ALL_LOADED:
        return state.merge({
            allResultsLoaded: true,
            resultCountString: state.allProducts.length.toString()
        });
    case singleEpixSortiment.EDIT_SINGLE_EPIX_FILTER:
        return state.merge(
            {
                allResultsLoaded: false,
                resultCountString: "0",
                chainFilter: {
                    ...action.change
                },
                allProducts: []
            },
            {
                deep: true
            }
        );
    case singleEpixSortiment.CLEAR_SINGLE_EPIX_SORTIMENT:
        return state.merge(
            {
                allProducts: []
            },
            {
                deep: true
            }
        );
    case singleEpixSortiment.SET_SINGLE_EPIX_SORTIMENT_FILTER:
        return state.merge(
            {
                chainFilter: {
                    onlyAvailableForChain: {
                        ...action.change
                    }
                }
            },
            {
                deep: true
            }
        );
    case singleEpixSortiment.SET_SINGLE_EPIX_PRODUCT_DETAIL:
        return state.merge(
            {
                productDetail: action.productDetail
            },
            {
                deep: true
            }
        );
    case singleEpixSortiment.CLEAR_SINGLE_EPIX_PRODUCT_DETAIL:
        return state.merge(
            {
                productDetail: {}
            },
            {
                deep: true
            }
        );
    case singleEpixSortiment.SET_INVOICE_GROUPS:
        return state.merge(
            {
                invoiceGroups: action.invoiceGroups
            },
            {
                deep: true
            }
        );
    case singleEpixSortiment.SET_QUERY_OPTION:
        return state.merge(
            {
                productGroups: action.productGroups,
                productSuppliers: action.productSuppliers
            },
            {
                deep: true
            }
        );
    case authentication.LOGGED_OUT:
        return defaultState();
    default:
        return state;
    }
}
